import React from 'react';

export const HideIcon = ({ color }: { color?: string }) => {
    return (
        <svg
            width='18'
            height='18'
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M10.8975 7.10391L7.1025 10.8989C6.615 10.4114 6.315 9.74391 6.315 9.00141C6.315 7.51641 7.515 6.31641 9 6.31641C9.7425 6.31641 10.41 6.61641 10.8975 7.10391Z'
               stroke={color ?? '#1D2939'}
                strokeWidth="1.5"
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.365 4.32687C12.0525 3.33687 10.5525 2.79688 9 2.79688C6.3525 2.79688 3.885 4.35687 2.1675 7.05687C1.4925 8.11437 1.4925 9.89188 2.1675 10.9494C2.76 11.8794 3.45 12.6819 4.2 13.3269'
               stroke={color ?? '#1D2939'}
                strokeWidth="1.5"
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M6.315 14.6492C7.17 15.0092 8.0775 15.2042 9 15.2042C11.6475 15.2042 14.115 13.6442 15.8325 10.9442C16.5075 9.88672 16.5075 8.10922 15.8325 7.05172C15.585 6.66172 15.315 6.29422 15.0375 5.94922'
               stroke={color ?? '#1D2939'}
                strokeWidth="1.5"
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M11.6325 9.52344C11.4375 10.5809 10.575 11.4434 9.51752 11.6384'
               stroke={color ?? '#1D2939'}
                strokeWidth="1.5"
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M7.1025 10.8984L1.5 16.5009'
               stroke={color ?? '#1D2939'}
                strokeWidth="1.5"
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M16.5 1.5L10.8975 7.1025'
               stroke={color ?? '#1D2939'}
                strokeWidth="1.5"
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};
